
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 5.8c0 8.298-5.098 12.924-8.308 14.262a1.8 1.8 0 01-1.384 0C6.294 18.389 2 13.243 2 5.8a1.8 1.8 0 011.108-1.662l7.2-3a1.8 1.8 0 011.384 0l7.2 3A1.8 1.8 0 0120 5.8zm-9 11.937l.002.001c3.516-1.75 6.47-5.862 6.594-11.54L11 3.45v14.287z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_segurado.svg